import { useLocation, Navigate } from "react-router-dom";
// material
import { styled } from '@mui/material/styles';
import { Stack, Container, Card, Typography } from '@mui/material';
// components
import Page from '../../../components/Page';
import FillInstallationReportDetails from "../../../components/SidebarMenuComponents/OAComponent/FillInstallationReportDetails";
import StickyHeader from "../../../components/Common/StickyHeader";

// ----------------------------------------------------------------------------------------------
const ContentStyle = styled('div')(({ theme }) => ({

    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1, 1)
}));
export default function FillInstallationReportDetailsPage() {
    const location = useLocation();
    const fillInstallation = location.state;

    return (
        <Page title="  Fill Installation Details| tiketic" >
           
            <StickyHeader title=" Fill Installation Details" />

            <ContentStyle>
                <FillInstallationReportDetails fillInstallation={fillInstallation} />
            </ContentStyle>
        </Page>
    );
}

